import 'reflect-metadata';
import { Container } from 'inversify';
import { TimezoneService } from '../timezone-service';
import { TimezoneServiceImpl } from '../impls/timezone-service';
import { beforeEach, describe, expect, it } from '@jest/globals';
import { UserService } from '@/domains/user/services/user-service.interface';
describe('时区服务', () => {
    let container;
    let timezoneService;
    const userService = {
        userSetting: {
            time_zone: {
                utc_offset: '+07:00',
            },
        },
    };
    beforeEach(() => {
        container = new Container();
        container.bind(TimezoneService).to(TimezoneServiceImpl);
        container.bind(UserService).toConstantValue(userService);
    });
    describe('测试没有注入 UserService 时的情况', () => {
        it('当用户选择东 8 区，转换为东 7 区和东 8 区，差值为 0', () => {
            // arrange
            const date = new Date('2024-10-31T07:00:00+08:00');
            // act
            timezoneService = container.get(TimezoneService);
            const tz7 = timezoneService.transformToTimeZoneTimestamp(date, 7);
            const tz8 = timezoneService.transformToTimeZoneTimestamp(date, 8);
            // assert
            expect(tz8 - tz7).toBe(0);
        });
        it('当用户选择东 7 区，转换为东 8 区和东 6 区，差值为 0', () => {
            // arrange
            const date = new Date('2024-10-31T07:00:00+07:00');
            // act
            timezoneService = container.get(TimezoneService);
            const tz6 = timezoneService.transformToTimeZoneTimestamp(date, 6);
            const tz8 = timezoneService.transformToTimeZoneTimestamp(date, 8);
            // assert
            expect(tz8 - tz6).toBe(0);
        });
        it('当用户选择 0 时区，转换为东 7 区和东 8 区，差值为 0', () => {
            // arrange
            const date = new Date('2024-10-31T07:00:00+00:00');
            timezoneService = container.get(TimezoneService);
            const tz7 = timezoneService.transformToTimeZoneTimestamp(date, 7);
            const tz8 = timezoneService.transformToTimeZoneTimestamp(date, 8);
            // assert
            expect(tz8 - tz7).toBe(0);
        });
    });
    describe('测试异常情况', () => {
        it('当用户选择的时间不是 Date 类型, 应该会报错"第 1 个参数必须传入 Date 类型"', () => {
            // arrange
            const date = '2024-10-31T07:00:00+08:00';
            // act
            timezoneService = container.get(TimezoneService);
            // assert
            expect(() => timezoneService.transformToTimeZoneTimestamp(date))
                .toThrow(/^第 1 个参数必须传入 Date 类型$/);
        });
        it('当用户选择的时区 offset 不是 -12 到 12 之间的数, 应该会报错"第 2 个参数必须传入 -12 到 12 之间的数"', () => {
            // arrange
            const date = new Date('2024-10-31T07:00:00+08:00');
            // act
            timezoneService = container.get(TimezoneService);
            // assert
            expect(() => timezoneService.transformToTimeZoneTimestamp(date, 13))
                .toThrow(/^第 2 个参数必须传入 -12 到 12 之间的数$/);
            expect(() => timezoneService.transformToTimeZoneTimestamp(date, '13'))
                .toThrow(/^第 2 个参数必须传入 -12 到 12 之间的数$/);
        });
    });
});
